import React from "react";
import organicFacialImg from "./../../../../../Images/FacialPage/Organic Cleanup Facial.png";
import "./OrganicFacialImg.css";
const OrganicFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={organicFacialImg} alt="organicFacialImg" />
    </div>
  );
};

export default OrganicFacialImg;
